import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { TwoFactorChallenge } from './TwoFactorChallenge';
import { TwoFactorEnrollment } from './TwoFactorEnrollment';

/**
 * Top-level auth gate (ADM-03): resolves loading/signed-out/unauthorized before any layout
 * or section route ever mounts, so an unauthenticated or rejected visitor never sees a blank
 * shell — they land on /login or /unauthorized immediately.
 */
export function RequireAuth() {
  const { status } = useAuth();

  if (status === 'loading') {
    return <div className="loading-screen">Loading…</div>;
  }
  if (status === 'signed-out') {
    return <Navigate to="/login" replace />;
  }
  if (status === 'unauthorized') {
    return <Navigate to="/unauthorized" replace />;
  }
  if (status === 'two-factor-required') {
    // Rendered instead of the Outlet so the Layout and every section page unmount; once the
    // code is accepted they remount and re-fetch with the verified token.
    return <TwoFactorChallenge />;
  }
  if (status === 'two-factor-enrollment-required') {
    // Same pattern: replaces the Outlet until the account has enrolled and acknowledged its
    // backup codes (or signed out).
    return <TwoFactorEnrollment />;
  }

  return <Outlet />;
}
